export enum NotificationType {
  MAIL = 'Mail',
  PUSH = 'Push'
}

export enum NotificationFormat {
  HTML = 'HTML',
  TEXT = 'TEXT'
}

export const NotificationTypeDisplay = {
  [NotificationType.MAIL]: 'Send me email notifications',
  [NotificationType.PUSH]: 'Send me push notifications'
};
